// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-toast {
  position: fixed;
  top: 80px;
  right: 0px;
  z-index: 1060;
}

.alerts-duration {
  position: absolute;
  width: 100%;
  height: 5px;
  bottom: -1px;
  animation: duration;
}

@keyframes duration {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/FabcoAlerts/FabcoAlerts.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI;IAAM,WAAA;EAER;EADE;IAAI,SAAA;EAIN;AACF","sourcesContent":[".up-toast {\n    position: fixed;\n    top: 80px;\n    right: 0px;\n    z-index: 1060;\n}\n\n.alerts-duration {\n    position: absolute;\n    width: 100%;\n    height: 5px;\n    bottom: -1px;\n    animation: duration;\n}\n\n@keyframes duration {\n    from {width: 100%;}\n    to {width: 0%;}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
